import React from 'react';
import { Col, Row, Container } from 'reactstrap';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import customer1 from '../../images/review/customer-1.jpg';
import customer2 from '../../images/review/customer-2.jpg';
import customer3 from '../../images/review/customer-3.jpg';
import Rating from '@material-ui/lab/Rating';
import FavoriteIcon from '@material-ui/icons/Favorite';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		'& > *': {
			margin: theme.spacing(1)
		}
	},
	large: {
		width: theme.spacing(12),
		height: theme.spacing(12)
	}
}));

const StyledRating = withStyles({
	iconFilled: {
		color: '#ff6d75'
	},
	iconHover: {
		color: '#ff3d47'
	}
})(Rating);

const Review = () => {
	const classes = useStyles();

	return (
		<section id="Review">
			<Container>
				<div className="d-flex justify-content-center mb-5">
					<h2 className="text-danger head-title mt-5">Reviews & Ratings</h2>
				</div>
				<Row className="mt-3 mb-5">
					<Col md={4}>
						<div>
							<div className={classes.root} className="d-flex justify-content-center">
								<Avatar alt="Alberto Duncan" src={customer1} className={classes.large} />
							</div>
							<div className="text-center">
								<h5 className="text-danger mt-4 mb-0">Mr. Albert Abuga</h5>
								<p className="text-secondary">Lecturer</p>

								<Box component="fieldset" mb={3} borderColor="transparent">
									<StyledRating
										name="customized-color"
										defaultValue={5}
										getLabelText={(value) => `${value} Heart${value !== 1 ? 's' : ''}`}
										precision={0.5}
										icon={<FavoriteIcon fontSize="inherit" />}
									/>
								</Box>

								<p className="mb-5">
									Nice work Tanasafi Team.I love your services and the way you keep up with time.Kudos!
								</p>
							</div>
						</div>
					</Col>
					<Col md={4}>
						<div>
							<div className={classes.root} className="d-flex justify-content-center">
								<Avatar alt="Albert Abuga" src={customer2} className={classes.large} />
							</div>
							<div className="text-center">
								<h5 className="text-danger mt-4 mb-0">Makena Mwiti</h5>
								<p className="text-secondary">Student</p>

								<Box component="fieldset" mb={3} borderColor="transparent">
									<StyledRating
										name="customized-color"
										defaultValue={4}
										getLabelText={(value) => `${value} Heart${value !== 1 ? 's' : ''}`}
										precision={0.5}
										icon={<FavoriteIcon fontSize="inherit" />}
									/>
								</Box>

								<p className="mb-5">
									I would really recommend Tanasafi for all your laundries.They are the best.I requested their services 
									and everything was clean,ironed and in order within 48hours.Wow!
								</p>
							</div>
						</div>
					</Col>
					<Col md={4}>
						<div>
							<div className={classes.root} className="d-flex justify-content-center">
								<Avatar alt="Makena Mwiti" src={customer3} className={classes.large} />
							</div>
							<div className="text-center">
								<h5 className="text-danger mt-4 mb-0">Kush Suleiman</h5>
								<p className="text-secondary">System Analyst</p>

								<Box component="fieldset" mb={3} borderColor="transparent">
									<StyledRating
										name="customized-color"
										defaultValue={5}
										getLabelText={(value) => `${value} Heart${value !== 1 ? 's' : ''}`}
										precision={0.5}
										icon={<FavoriteIcon fontSize="inherit" />}
									/>
								</Box>

								<p className="mb-5">
									Goodwork guys.I love the good technology in your system, the responsiveness,the realtimeness and the nice and interactive UI
								is a perfect reflection of your laundry services:Clean and Organized.Well done!
								</p>
							</div>
						</div>
					</Col>
				</Row>
			</Container>
		</section>
	);
};

export default Review;
